module.exports = __webpack_public_path__ + "img/coffee-bean.00ab8296.svg";